module.exports = __webpack_public_path__ + "static/media/not_permitted.d1e84eba.png";